export default theme => ({
    // Fixed right-side overlay. Sits above the top bar (appBar) but below MUI
    // modals (modal), so the assistant's own dialogs still layer on top of it.
    sidebar: {
        position: 'fixed',
        top: 0,
        right: 0,
        bottom: 0,
        width: 420,
        maxWidth: '100vw',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[8],
        zIndex: theme.zIndex.appBar + 2,
    },
    // Floating pop-up anchored to the bottom-right corner. Leaves the rest of the
    // page visible/interactive, unlike the full-height side panel. Same layering.
    widget: {
        position: 'fixed',
        bottom: theme.spacing(2),
        right: theme.spacing(2),
        width: 420,
        height: 600,
        maxWidth: `calc(100vw - ${theme.spacing(4)})`,
        maxHeight: `calc(100vh - ${theme.spacing(4)})`,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[8],
        borderRadius: theme.shape.borderRadius * 3,
        zIndex: theme.zIndex.appBar + 2,
    },
});
